import getUserForUsersArray from '../helpers/getUserForUsersArray'

function updateApprovedUsersArray({ input, state }) {
  let users = state.get('users.approved')
  // only add if we have loaded the users
  if (users) {
    let newUser = getUserForUsersArray(input, state)
    let didMerge = false
    users.forEach((user, index) => {
      if (user._id === newUser._id) {
        didMerge = true
        state.set(`users.approved.${index}`, newUser)
      }
    })
    if (!didMerge) {
      state.push('users.approved', newUser)
    }
  }
}

export default updateApprovedUsersArray



// WEBPACK FOOTER //
// ./src/modules/user/actions/updateApprovedUsersArray.js